export const sanitizeString = (str) => str.trim(); // Add more sanitization logic as needed
export const sanitizeArray = (arr) => arr;